module.exports = "https://pm2019.reeltime.no/public/images/pm_logo_new_text.01d49536.png";